import { render, staticRenderFns } from "./PhotoSelectorComponent.vue?vue&type=template&id=55c16a10&scoped=true&"
import script from "./PhotoSelectorComponent.vue?vue&type=script&lang=js&"
export * from "./PhotoSelectorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c16a10",
  null
  
)

export default component.exports